'use client'

import { Button } from '@vinted/web-ui'

import { useTracking } from '@marketplace-web/shared/event-tracker'
import { getFingerprint } from '@marketplace-web/domain/audit'
import { ClickableElement } from 'constants/tracking/clickable-elements'
import {
  landingPageEvent,
  ElectronicsBottomSectionModel,
  ElectronicsBottomCtaClickEvents,
  ElectronicsBottomLinkClickEvents,
  ElectronicsLandingPageEvent,
} from '@marketplace-web/domain/marketing-landing-page-data'

import useElectronicsLpVersion from '../../hooks/useElectronicsLpVersion'

type Props = { content: ElectronicsBottomSectionModel }

const BottomSection = ({
  content: { title, description, ctaText, ctaUrl, linkText, linkUrl },
}: Props) => {
  const { track } = useTracking()
  const lpVersion = useElectronicsLpVersion()

  const clickAction = async (
    event: ElectronicsLandingPageEvent,
    target: ClickableElement,
    targetDetails: string,
  ) => {
    track(
      landingPageEvent({
        event,
        target,
        targetDetails,
        deviceId: await getFingerprint(),
      }),
    )
  }

  const handleOnLinkClick = async () =>
    clickAction(ElectronicsBottomLinkClickEvents[lpVersion], ClickableElement.TextLink, linkUrl)

  const handleOnCtaClick = async () =>
    clickAction(ElectronicsBottomCtaClickEvents[lpVersion], ClickableElement.CtaRedirect, ctaUrl)

  return (
    <section data-testid="bottom-section" className="electronics__bottom-section">
      <h2 className="electronics__bottom-title">{title}</h2>
      <p className="electronics__bottom-description">{description}</p>
      <div className="electronics__bottom-cta">
        <Button
          size={Button.Size.Default}
          styling={Button.Styling.Filled}
          text={ctaText}
          url={ctaUrl}
          testId="electronics-bottom-cta"
          onClick={handleOnCtaClick}
        />
      </div>
      <div className="electronics__bottom-link">
        <a href={linkUrl} onClick={handleOnLinkClick} data-testid="electronics-bottom-link">
          {linkText}
        </a>
      </div>
    </section>
  )
}

export default BottomSection
